import { NavLink } from 'react-router-dom'
import {
  ChartBarIcon,
  GlobeAltIcon,
  UserGroupIcon,
  PresentationChartLineIcon,
  DocumentChartBarIcon,
  CurrencyDollarIcon,
  CalendarDaysIcon,
  RocketLaunchIcon,
  XMarkIcon
} from '@heroicons/react/24/outline'

const navigation = [
  {
    name: 'Revenue',
    items: [
      { name: 'Overview', href: '/revenue/overview', icon: ChartBarIcon },
      { name: 'Country Report', href: '/revenue/country', icon: GlobeAltIcon },
      { name: 'Customer Report', href: '/revenue/customer', icon: UserGroupIcon },
    ]
  },
  {
    name: 'Marketing & Sales',
    items: [
      { name: 'Overview', href: '/marketing/overview', icon: PresentationChartLineIcon },
      { name: 'Deals', href: '/marketing/deals', icon: DocumentChartBarIcon },
    ]
  },
  {
    name: 'Financial Targets',
    items: [
      { name: 'Overview', href: '/financial/overview', icon: CurrencyDollarIcon },
      { name: 'Month over Month', href: '/financial/mom', icon: CalendarDaysIcon },
    ]
  },
  {
    name: 'Onboarding',
    items: [
      { name: 'Dashboard', href: '/onboarding', icon: RocketLaunchIcon },
    ]
  }
]

export default function Sidebar({ open, onClose }) {
  return (
    <>
      {/* Mobile backdrop */}
      {open && (
        <div
          className="fixed inset-0 bg-gray-900/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 left-0 z-50 h-full w-64 bg-sidebar-gradient
          transform transition-transform duration-300 ease-in-out
          ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="flex items-center justify-between h-16 px-4 border-b border-white/10">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <ChartBarIcon className="w-5 h-5 text-brand-600" />
              </div>
              <span className="text-white font-semibold text-lg">Analytics</span>
            </div>
            <button
              onClick={onClose}
              className="lg:hidden p-1 text-white/70 hover:text-white rounded"
            >
              <XMarkIcon className="w-6 h-6" />
            </button>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto py-4 px-3 scrollbar-thin">
            {navigation.map((section) => (
              <div key={section.name} className="mb-6">
                <h3 className="px-3 text-xs font-semibold text-white/50 uppercase tracking-wider mb-2">
                  {section.name}
                </h3>
                <ul className="space-y-1">
                  {section.items.map((item) => (
                    <li key={item.href}>
                      <NavLink
                        to={item.href}
                        onClick={onClose}
                        className={({ isActive }) =>
                          `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                            isActive
                              ? 'bg-white/20 text-white'
                              : 'text-white/70 hover:bg-white/10 hover:text-white'
                          }`
                        }
                      >
                        <item.icon className="w-5 h-5 flex-shrink-0" />
                        {item.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-white/10">
            <div className="text-xs text-white/40 text-center">
              B2B SaaS Analytics
            </div>
          </div>
        </div>
      </aside>
    </>
  )
}
